import React from 'react'
import { YapContentPreview } from '@yapstudios/yap-content-builder'
import { Section, Stack, Text, Image, YapAssetImage, Gallery, Video, Calendar, Quiz, ActionButton, Info, ZStack } from '@yapstudios/yap-content-builder'
import './styles.css'
import { styles, fonts } from "./CBStyles.js"
import { feedComponents } from './CollegeboardMessageFeedLibrary.js'
import { CBMessageCard } from './CBMessageCard.js'

export interface CBMessageFeedPreviewProps {
    /**
     * Width of preview
     */
    width: number;

    /**
     * Title of the page
     */
    title?: string;

    /**
     * Message content
     */
    messages: CBMessageCard[]
    placeholderMessages: CBMessageCard[];

    /**
     * Title to show in header.
     */
    headerMessage?: string;

    /**
     * Logo URL (overrides all cards)
     */
    logo?: string;

    /**
     * Logo Avatar URL (overrides all cards)
     */
    logoAvatar?: string;

    /**
     * Institution Title (overrides all cards)
     */
    institutionTitle?: string;

    /**
     * Defines if should be presented in dark mode
     */
    dark?: boolean;

    /**
     * Elements to hide from screen readers. Visible by default.
     */
    ariaHidden?: ('title' | 'subtitle')[]
}

/**
* Presents a preview of a message in a feed
* @component
*/
function CBMessageFeedPreview(props: CBMessageFeedPreviewProps) {

    let headerMessage = props.headerMessage

    let extraMessages = (props.placeholderMessages ?? props.messages ?? []).flatMap( (message, idx) => {
        return [
            {
                'id': 'message',
                'type': 'message-card',
                'props': { ...message,
                           'logo': message.logo ?? props.logo, 
                           'logoAvatar' : message.logoAvatar ?? props.logoAvatar,
                           'institutionTitle' : message.institutionTitle ?? props.institutionTitle,
                           'logoType' : message.logoType,
                           'image': message.image, 
                           'placeholder': idx == 0,
                           'title': message.title }
            }
        ]
    })

    let sections : any[] = [
        {
            'id': 'feed-header',
            'type': 'feed-header',
            'props': { title: props.title, 
                       subtitle: headerMessage,
                       ariaHidden: props.ariaHidden }
        }
    ]

    let page = {
        id: 'page-1',
        sections: sections.concat(extraMessages)
    }
    
    return <YapContentPreview styles={styles} fonts={fonts} dark={props.dark} components={feedComponents} {...props} page={page} />
}

export default CBMessageFeedPreview